import { useEffect, useState } from 'react';

/**
 * Custom hook for animated number counting
 * @param {number} target - Target number to count to
 * @param {number} duration - Duration in milliseconds
 * @param {boolean} start - Whether to start the animation
 * @param {Function} formatter - Optional formatter function (e.g., for currency)
 * @returns {string|number} - Current count value
 */
export const useCounter = (target, duration = 2000, start = false, formatter = null) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!start) return;

        let startTime = null;
        const startValue = 0;

        const animate = (currentTime) => {
            if (startTime === null) startTime = currentTime;
            const progress = Math.min((currentTime - startTime) / duration, 1);

            // Easing function (ease-out)
            const easeOut = 1 - Math.pow(1 - progress, 3);
            const currentCount = Math.floor(startValue + (target - startValue) * easeOut);

            setCount(currentCount);

            if (progress < 1) {
                requestAnimationFrame(animate);
            } else {
                setCount(target);
            }
        };

        requestAnimationFrame(animate);
    }, [target, duration, start]);

    return formatter ? formatter(count) : count;
};

